module.exports = __webpack_public_path__ + "img/back.62c1d558.svg";